import Hero from '../components/Home/Hero';
import ServiceCard from '../components/Home/ServiceCard';
import ImageStack from '../components/Home/ImageStack';

import { shortServiceCatergories } from '../constants/data';
import { ServiceCategory } from '../types';
import { ArrowRight, Award, Users, ClipboardCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

import aushubmaterialien from '../assets/fphc_aushubmaterialien.png';
import boden from '../assets/fphc_boden.png';
import abwasser from '../assets/fphc_abwasser.png';
import cave from '../assets/fphc_cave.jpeg';

const Home = () => {
  const calculateYearsSince = (year: number, month: number, day: number) => {
    const startDate = new Date(year, month - 1, day); // month is 0-based
    const today = new Date();
    
    let years = today.getFullYear() - startDate.getFullYear();
    let months = today.getMonth() - startDate.getMonth();
    let days = today.getDate() - startDate.getDate();

    // Adjust for negative months or days
    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    return years;
  };

  const experienceYears = calculateYearsSince(2011, 10, 17); // 2011-10-17
  const accreditationYears = calculateYearsSince(2019, 6, 26); // 2019-06-26

  const images = [
    {
      src: aushubmaterialien,
      alt: "Excavation materials"
    },
    {
      src: boden,
      alt: "Soil analysis"
    },
    {
      src: abwasser,
      alt: "Wastewater treatment"
    }
  ];

  return (
    <div>
      <Hero />
      
      <section className="relative py-16 sm:py-24 bg-gradient-to-b from-dark to-dark/95 text-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
            <div className="text-center">
              <Award className="w-10 h-10 sm:w-12 sm:h-12 text-success mx-auto mb-3 sm:mb-4" />
              <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">{experienceYears}+ Jahre</h3>
              <p className="text-gray-300 text-sm sm:text-base">Branchenerfahrung</p>
            </div>
            <div className="text-center">
              <Users className="w-10 h-10 sm:w-12 sm:h-12 text-success mx-auto mb-3 sm:mb-4" />
              <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">350+</h3>
              <p className="text-gray-300 text-sm sm:text-base">Zufriedene Kunden</p>
            </div>
            <div className="text-center sm:col-span-2 md:col-span-1">
              <ClipboardCheck className="w-10 h-10 sm:w-12 sm:h-12 text-success mx-auto mb-3 sm:mb-4" />
              <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">{accreditationYears}+ Jahre</h3>
              <p className="text-gray-300 text-sm sm:text-base">Akkreditierte Inspektionsstelle</p>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-0 left-0 w-full h-16 sm:h-24 overflow-hidden">
          <div className="absolute bottom-0 left-0 w-full h-full bg-[#B5E2BF]" 
               style={{
                 clipPath: 'polygon(0 100%, 100% 100%, 100% 40%, 0% 100%)'
               }}
          />
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#B5E2BF]">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            <div className="space-y-6 sm:space-y-8">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-dark leading-tight">
                Bewertung von Abfällen und Aushubmaterialien, Abbruch und Recyclingmaterialien, Brauch- und Abwässern sowie Projektierungen
              </h2>
              <div className="w-16 sm:w-24 h-0.5 bg-dark/20" />
              <p className="text-base sm:text-lg text-dark/80">
                Wir beraten und betreuen Sie gerne bei allen umweltrelevanten Fragen und begleiten Ihr Projekten im In- und Ausland als kompetenter Partner.
              </p>
            </div>
            
            <ImageStack images={images} />
            
          </div>
        </div>
      </section>
      
      <section className="py-16 sm:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-16">
            <div className="flex items-center justify-center space-x-2 mb-3 sm:mb-4">
              <div className="h-1 w-8 sm:w-12 bg-success rounded-full" />
              <span className="text-success uppercase tracking-wider text-xs sm:text-sm font-medium">Unsere Leistungen</span>
              <div className="h-1 w-8 sm:w-12 bg-success rounded-full" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">Umfassende Umweltlösungen</h2>
            <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
              Entdecken Sie unser umfangreiches Angebot, wodurch wir Ihr Unternehmen in allen umweltrelevanten Aufgabenstellungen professionell begleiten können.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {shortServiceCatergories.map((category: ServiceCategory, index: number) => (
              <ServiceCard key={category.id} service={category} index={index} />
            ))}
          </div>
        </div>
      </section>
      
      <section className="relative">
        <div className="absolute top-0 left-0 w-full h-16 sm:h-24 overflow-hidden transform rotate-180">
          <div className="absolute bottom-0 left-0 w-full h-full bg-gray-50" 
               style={{
                 clipPath: 'polygon(0 100%, 100% 100%, 100% 40%, 0% 100%)'
               }}
          />
        </div>

        <div className="relative h-[500px] sm:h-[500px] lg:h-[600px]">
          <div className="absolute inset-0">
            <img 
              src={cave}
              alt="Cave background"
              className="w-full h-full object-cover brightness-[0.85]"
            />
            <div className="absolute inset-0 bg-black/40" />
          </div>
          
          <div className="absolute inset-0 flex items-center sm:items-start justify-start p-4 sm:p-12">
            <div className="w-full sm:w-auto mx-4 sm:mx-0 space-y-4 sm:space-y-6 backdrop-blur-sm bg-black/20 p-4 sm:p-8 rounded-2xl">
              <div className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl">
                <div className="flex gap-1">
                  <div className="w-2.5 h-2.5 bg-[#75B2DD] rounded-[2px] animate-pulse-first"></div>
                  <div className="w-2.5 h-2.5 bg-[#B5E2BF] rounded-[2px] animate-pulse-second"></div>
                  <div className="w-2.5 h-2.5 bg-[#009E60] rounded-[2px] animate-pulse-third"></div>
                </div>
                <span className="text-success font-medium text-sm sm:text-base">Umwelttechnologie der Zukunft</span>
              </div>
              
              <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight drop-shadow-lg">
                Bereit für <span className="text-[#B5E2BF]">nachhaltige</span> Lösungen?
              </h2>
              
              <div className="w-16 sm:w-20 h-1 sm:h-1.5 bg-gradient-to-r from-success to-success/30 rounded-full" />
              
              <p className="text-white text-sm sm:text-lg leading-relaxed drop-shadow">
                Unser kompetentes Team freut sich darauf, Ihnen bei all Ihren Herausforderungen durch innovative Lösungen tatkräftig zur Seite zu stehen.
              </p>

              <Link
                to="/contact"
                className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl transition-all duration-300 group text-sm sm:text-base"
              >
                <span>Jetzt Kontaktieren</span>
                <ArrowRight className="w-4 sm:w-5 h-4 sm:h-5 transform group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
          
          <div className="absolute bottom-0 left-0 w-full h-24 sm:h-32 bg-white"
               style={{
                 clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 40%)'
               }}
          />
        </div>
      </section>
    </div>
  );
};

export default Home;